$( document ).ready(function() {
  
  var prev_arrow = '<div class="slide-arrow prev-arrow"><svg width="33" height="62" viewBox="0 0 33 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 61L2 31L32 1" stroke="black" stroke-width="2"/></svg></div>';
  var next_arrow = '<div class="slide-arrow next-arrow"><svg width="33" height="62" viewBox="0 0 33 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.00001 0.999997L31 31L1 61" stroke="black" stroke-width="2"/></svg></div>';
  
  $('.featured-coll-slider').slick({
    centerMode: true,
    centerPadding: '511px',
    slidesToShow: 1,
    arrows: true,
    prevArrow: prev_arrow,
    nextArrow: next_arrow,
    responsive: [
      {
        breakpoint: 1651,
        settings: {
          centerPadding: '440px',
        }
      },
      {
        breakpoint: 1451,
        settings: {
          centerPadding: '340px',
        }
      },
      {
        breakpoint: 1280,
        settings: {
          centerPadding: '240px',
        }
      },
      {
        breakpoint: 1110,
        settings: {
          centerPadding: '180px',
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          slidesToShow: 1
        }
      }
    ]
  });

  var prev_arrow_white = '<div class="slide--arrow prev--arrow"><svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 34L2 17.5L19 1" stroke="white" stroke-width="2"/></svg></div>';
  var next_arrow_white = '<div class="slide--arrow next--arrow"><svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.999998L18 17.5L1 34" stroke="white" stroke-width="2"/></svg></div>';
  
  $('.sgc-slider').slick({
    slidesToShow: 1,
    prevArrow: prev_arrow_white,
    nextArrow: next_arrow_white,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
        }
      }
    ]
  });

  $('.store-address-line').click(function() {
    $(this).parents('.store-location-section').find('.store-location-slider').toggleClass('min-height');
    $(this).toggleClass('active');
    $(this).parents('.store-details-content').find('.store-address').toggleClass('hide');
  });

  $('.banner--link--label').click(function () {
    if ($('.shp-women').hasClass('active')) {
      var col_links = $('.shp-women.active').attr('data-href');
      if (col_links != 'undefined') {window.location.href = col_links;}
    }
  });
  
  $('.banner--link--label-2').click(function () {
    if ($('.shp-men').hasClass('active')) {
      var col_links_2 = $('.shp-men.active').attr('data-href');
      if (col_links_2 != 'undefined') {window.location.href = col_links_2;}
    }
  });

  $('.store-details-collection-slider').on("afterChange", function(ev, slick, current, next) {
    if (!$('.slick-next').hasClass('slick-disabled')) {
      $('.banner--link--label-2').text('MENS');
      $('.shp-men').removeClass('active');
      $('.shp-men').attr('data-href', '');
      
    } else {
      $('.banner--link--label-2').text('SHOP MENS');
      $('.shp-men').addClass('active');
      var col_link = $('.men-shop a').attr('href');
      $('.shp-men').attr('data-href', col_link);
      
    } 
    if (!$('.slick-prev').hasClass('slick-disabled')) {
      $('.banner--link--label').text('WOMENS');
      $('.shp-women').removeClass('active');
      $('.shp-women').attr('data-href', '');
      
    } else {
      $('.banner--link--label').text('SHOP WOMENS');
      $('.shp-women').addClass('active');
      var col_link = $('.women-shop a').attr('href');
      $('.shp-women').attr('data-href', col_link);
      
    }
  });
  
  $('.sgc-banner--btn').click(function() {
    $(this).addClass('active').siblings().removeClass('active');
    var data_title = $(this).attr('data-title');
    var data_btn = $(this).attr('data-name');
    
    if ($('.shp-women').hasClass('active')) {
      if (data_title != '') {
        $('.banner--link--label').text('SHOP WOMENS');
        var col_link = $('.women-shop a').attr('href');
        $('.shp-women').attr('data-href', col_link);
      }
    } else {
      if (data_title != '') {
        $('.banner--link--label').text('WOMENS');
        $('.shp-women').attr('data-href', '');
      }
    }
    if ($('.shp-men').hasClass('active')) {
      if (data_title != '') {
        $('.banner--link--label-2').text('SHOP MENS');
        var col_link = $('.men-shop a').attr('href');
        $('.shp-men').attr('data-href', col_link);
      }
    } else {
      if (data_title != '') {
        $('.banner--link--label-2').text('MENS');
        $('.shp-men').attr('data-href', '');
      }
    }
    
    $('.feature-media__item').each(function (e) {
      var data_name = $(this).attr('data-btn');
      if (data_name == data_btn) {
        $(this).addClass('active').siblings().removeClass('active');
      }
    });
    
  });

  $('.shp-men').click(function(){
    $('.slick-next').trigger('click');
  });

  $('.shp-women').click(function(){
    $('.slick-prev').trigger('click');
  });

  var windowSize = $(window).width();
  if (windowSize <= 767) {
    
    if ($('.banner--link--label-2').text() != '') {
      $('.banner--link--label-2').text('MENS');
    }
    
    $('.store-details-collection-slider').slick({
      slidesToShow: 1,
      slidesToShow: 1,
      arrows: true,
      dots: false,
      infinite: false,
      swipeToSlide: true
    });
    
  }
  if (windowSize <= 700) {
    $('.store-location-slider').slick({
      slidesToShow: 1,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            dots: true,
            appendDots:$('.slick_dots'),
            arrows: false,
          }
        }
      ]
    });
    $('.store-location-slider').on("afterChange", function(ev, slick, current, next) {
      // console.log('ev',ev,'slick',slick,'current',current,'next',next);
       $('.slick_dots').each(function(){
          $(this).find('li:eq('+ current +')').addClass('slick-active').siblings('li').removeClass('slick-active');
      })
    });
    $('.slick_dots li').click(function(){
    $(this).addClass('active');
      var inde = $(this).index();
      console.log(inde)
      $('.slick_dots').each(function(){
          $(this).find('li:eq('+ inde +')').addClass('slick-active').siblings('li').removeClass('slick-active');
      })
    
    });
    
  }

  var prev_arrow_new = '<div class="slide-arrow prev-arrow"><svg width="25" height="25" viewBox="0 0 33 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 61L2 31L32 1" stroke="black" stroke-width="2"/></svg></div>';
  var next_arrow_new = '<div class="slide-arrow next-arrow"><svg width="25" height="25" viewBox="0 0 33 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.00001 0.999997L31 31L1 61" stroke="black" stroke-width="2"/></svg></div>';

  $('.new_product').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: prev_arrow_new,
    nextArrow: next_arrow_new,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  $('.line-item-property__field .in_put').focusin(function(){
    // $(this).parent().siblings().find('label').show();
    $(this).prev('label').hide();
  })



     var lastTwoImages = $(".custom-orders .pro_mob_img .mob_images").slice(-2);
      $(".variant-input-1, .variant-input-2").change(function() {
          var Selected_option = [];
          $('.variant-input-1, .variant-input-2').each(function() {
            Selected_option.push(this.value);
          });
          var variant_title = Selected_option.join("_");
          // for desktop
            $(".custom-orders .product-image-stack img").parents(".product-image-stack").addClass("hide");
            $(".custom-orders .product-image-stack img").parents(".product-image-stack").removeClass("show");
            // console.log("variant_title", variant_title)
            $(".custom-orders .product-image-stack img[alt='" + variant_title + "']").parents(".product-image-stack").removeClass("hide");
            $(".custom-orders .product-image-stack img[alt='" + variant_title + "']").parents(".product-image-stack").addClass("show");
            var show_img = $(".custom-orders .product-image-stack.show");
            if(show_img.length > 0){
                show_img.get().reverse().forEach(function(element) {
                  $(element).prependTo($(element).parent());
                });
            };
            lastTwoImages.each(function() {
              $(this).attr("data-cmpr", variant_title);
            });
          // for mobile
            var filter = $(this).val();
            $(".custom-orders .pro_mob_img").slick('slickUnfilter');
            $(".custom-orders .pro_mob_img").slick('slickFilter','[data-cmpr="' + variant_title + '"]');
            $('.custom-orders .pro_mob_img').slick('slickGoTo', 0)
      })
      

      //on load
      var Selected_option = [];
      $('.variant-input-1, .variant-input-2').each(function() {
            Selected_option.push(this.value);
      });
      var variant_title = Selected_option.join("_");
      console.log("variant_title", variant_title);
      $(".custom-orders .product-image-stack img").parents(".product-image-stack").addClass("hide");
      $(".custom-orders .product-image-stack img").parents(".product-image-stack").removeClass("show");
      
      $(".custom-orders .product-image-stack img[alt='" + variant_title + "']").parents(".product-image-stack").addClass("show");
      $(".custom-orders .product-image-stack img[alt='" + variant_title + "']").parents(".product-image-stack").removeClass("hide");
      var show_img = $(".custom-orders .product-image-stack.show");
        if(show_img.length > 0){
            show_img.get().reverse().forEach(function(element) {
                  $(element).prependTo($(element).parent());
                });
      }; 
      lastTwoImages.each(function() {
          $(this).attr("data-cmpr", variant_title);
      });
  
      $(".custom-orders .pro_mob_img").slick('slickUnfilter');
      $(".custom-orders .pro_mob_img").slick('slickFilter','[data-cmpr="' + variant_title + '"]'); 




var dotNums = document.querySelectorAll(".slick-dots button");

  function removeText(item) {
    item.innerHTML = ""; // or put the text you need inside quotes
  }

  dotNums.forEach(removeText);

  
});







